<template>
  <aside>
    <div class="chatbot">
      <!-- v-if="!isChatActive" -->
      <div v-if="!isChatActive" class="starter" @click="activateChat">
      </div>

      <!-- v-else -->
      <div v-else class="chatWindow">
        <div v-if="showLoading" class="loader" :class="{ 'loaded': !showLoading }">
          <v-img width="122" :src="require('@/assets/images/svg/logoDark1.svg')"></v-img>
        </div>
        <div v-else class="chatContainer">
          <div class="header">
            <span>BLDON Assistance</span>
            <v-icon class="closeButton" style="cursor: pointer" @click="closeChat">{{ icon.mdiCloseCircle }}</v-icon>
          </div>

          <div class="body">
            <div v-for="item in messages">
              <div class="aiMessage" v-if="item.t == 0">
                <div class="msg">
                  <div>{{ item.msg }}</div>
                  <CsvExporter v-if="item.outputData" :jsonData="item.outputData" />
                </div>
                <div class="logo">
                  <v-img :src="require('@/assets/images/svg/logoDark1.svg')" height="30" width="30" :style="{}"></v-img>
                </div>
              </div>
              <div class="userMessage" v-else>
                <div class="logo">L</div>
                <div class="msg">{{ item.msg || item.q }}</div>
              </div>
            </div>
          </div>
          <div class="footer">
            <div>
              <textarea v-model="inputMessage" placeholder="Type your message here..."></textarea>
            </div>
            <v-btn :loading="loading" class="send" @click="send">
              Send
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>

import { ref } from '@vue/composition-api'
import FolderImg from '@/assets/images/svg/folder.svg'
import { formatDate } from '@core/utils/filter'
import chatService from './chatService'
import { mdiCloseCircle } from '@mdi/js'
import Toaster from '@core/utils/sweetToast'
import CsvExporter from './CsvExport.vue'

export default {
  components: { CsvExporter },
  setup() {
    const isChatActive = ref(false);
    const showLoading = ref(false);
    const loading = ref(false);
    const inputMessage = ref('');
    const messages = ref([
      {
        t: '0',
        msg: 'Welcome to BLDON AI Assistance. How can I help you today?',
        outputData: null,
      }
    ])
    const { sendMsg } = chatService();

    const activateChat = () => {
      showLoading.value = true;
      isChatActive.value = true;
      setTimeout(() => {
        showLoading.value = false;
      }, 2000);
    }

    const closeChat = () => {
      Toaster.confirmation("Are you sure you want to close the chat?").then(resp => {
        if (resp.isConfirmed) {
          isChatActive.value = false;
          messages.value = [{
            t: '0',
            msg: 'Welcome to BLDON AI Assistance. How can I help you today?'
          }];
        }
      })
    }

    const send = async () => {
      loading.value = true;
      if (!inputMessage.value) {
        loading.value = false;
        return;
      }
      const data = {
        q: inputMessage.value || "count the critical inventory items where item less then 300 and greater than 50",
        c: data?.c || "Inventory"
      }
      messages.value.push({
        t: 1,
        ...data
      })
      try {
        const out = await sendMsg(data);
        console.log('******************************');
        console.log(out);
        const itemCount = Array.isArray(out.data) ? out.data.length : null;
        if (itemCount && itemCount == 1) {
          const keys = Object.keys(out.data[0]);
          console.log(keys[0])
          if (keys[0].includes('count') || keys[0].includes('total')) {
            messages.value.push({
              t: 0,
              msg: `Total count is ${out.data[0][keys[0]]}`,
            });
            return;
          }
        }
        messages.value.push({
          t: 0,
          msg: itemCount ? `There are ${itemCount} items available` : out.data,
          outputData: itemCount ? out.data : null
        });

      } catch (error) {
        console.error("Error sending message:", error);
        messages.value.push({
          t: 0,
          msg: "Sorry, there was an error sending your message. Please try again."
        });
      } finally {
        inputMessage.value = '';  // Clear the input after sending
        loading.value = false;    // Stop the loading indicator
      }
    }

    return {
      isChatActive,
      showLoading,
      loading,
      inputMessage,
      messages,
      formatDate,
      icon: {
        FolderImg,
        mdiCloseCircle
      },
      activateChat,
      closeChat,
      send
    }
  },
}
</script>

<style scoped lang="scss">
.v-image__image {
  background-position: 10% 50% !important;
  background-size: 125px !important;
}

.chatbot {
  .starter {
    position: fixed;
    right: 0;
    bottom: 0;
    width: 50px;
    height: 50px;
    background-color: #10294c;
    border-radius: 50%;
    margin: 10px;
    cursor: pointer;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .chatWindow {
    width: 320px;
    height: 450px;
    background: #fff;
    bottom: 0;
    position: fixed;
    right: 0;
    margin: 10px;
    border: 1px solid #10294c;
    overflow: hidden;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.1);

    .loader {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 1;
      top: 0;
      background-color: #ccc;
      background-color: #10294c;
      transform: translateY(0);
      transition: all 0.2s ease-out;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .loader.loaded {
      transform: translateY(100%);
    }

    .header {
      height: 30px;
      text-align: center;
      line-height: 1.8;
      // border-bottom: 1px solid  #10294c;
      background-color: #10294c;
      color: #fff;
    }

    .closeButton {
      background: none;
      border: none;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
      position: absolute;
      right: 8px;
      top: 2px;
    }

    .body {
      height: calc(100% - 80px);
      position: absolute;
      width: 100%;
      top: 0;
      margin-top: 30px;
      overflow: auto;

      .logo {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        text-align: center;
        border: 1px solid #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
      }

      .userMessage {
        width: 90%;
        display: flex;
        padding: 5px;
        align-items: flex-start;
        justify-content: flex-start;
        padding-bottom: 10px;

        .logo {
          margin-right: 10px;
          background-color: #10294c;
        }

        .msg {
          border: 1px solid;
          width: 80%;
          min-height: 30px;
          display: flex;
          align-items: center;
          padding: 10px;
          border-radius: 20px;
          border-top-left-radius: 0;
          max-width: 80%;
        }
      }

      .aiMessage {
        // width: 90%;
        display: flex;
        padding: 5px;
        align-items: flex-start;
        justify-content: end;
        padding-bottom: 10px;

        .logo {
          margin-left: 10px;
          background-color: #fe724c;
        }

        .msg {
          border: 1px solid;
          // width: 80%;
          min-height: 30px;
          display: flex;
          align-items: center;
          padding: 10px;
          border-radius: 20px;
          border-top-right-radius: 0;
          text-align: left;
          max-width: 80%;
          flex-flow: column;
        }
      }
    }

    .footer {
      height: 50px;
      background-color: #fff;
      position: absolute;
      bottom: 0;
      width: 100%;
      display: flex;
      align-items: center;
      border-top: 1px solid #10294c;

      textarea {
        border: 1px solid;
        margin: 6px;
        padding: 2px;
        width: 245px;
      }

      .send {
        cursor: pointer;
        height: 40px;
        text-align: center;
        line-height: 1.8;
        background-color: #10294c;
        color: #fff;
        padding: 8px 10px !important;
        display: flex;
        align-items: center;
        min-width: auto !important;
      }
    }
  }
}
</style>
